export default __webpack_public_path__ + "static/media/exploreicons_mobile.abcfd7d0.png";